export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-xl p-8 md:p-12 text-center overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-background-50"></div>
            <div className="absolute -bottom-8 -left-8 w-36 h-36 rounded-full bg-background-50"></div>
          </div>

          <div className="relative z-10">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-background-50/20 text-background-50">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              我要爆料
            </h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-6 leading-relaxed">
              你有独家内幕或一手爆料？每日黑料网欢迎每一位吃瓜群众的投稿。
              你的线索可能成为下一个全网热议的焦点话题，让我们一起揭开真相。
            </p>
            <a
              href="#faq"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-semibold text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              <i className="ri-information-line text-lg"></i>
              了解投稿方式
            </a>
            <div className="flex flex-wrap items-center justify-center gap-4 mt-5 text-xs text-background-50/60">
              <span><i className="ri-shield-check-line mr-1"></i>严格保护爆料人隐私</span>
              <span><i className="ri-time-line mr-1"></i>24小时内审核回复</span>
              <span><i className="ri-award-line mr-1"></i>优质爆料有奖励</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}